<template>
  <div class="form-miembro-wrapper">
    <v-stepper v-model="e6" vertical class="dark-stepper">
      <!-- Paso 1: Datos personales -->
      <v-stepper-step :complete="e6 > 1" step="1">
        Datos personales
        <small>Escribe los datos personales</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-form ref="formPaso1" v-model="formDatosPersonales" class="dark-form">
          <div class="step-card">
            <div class="field">
              <label class="field-label">Nombre completo</label>
              <v-text-field
                :rules="reglasNombre"
                v-model="datosPersonales.nombre"
                outlined
                dense
                hide-details="auto"
                placeholder="Ej. María López"
                class="dark-input"
              ></v-text-field>
            </div>

            <div class="field">
              <label class="field-label">Teléfono / celular</label>
              <v-text-field
                :rules="reglasTelefono"
                v-model="datosPersonales.telefono"
                outlined
                dense
                hide-details="auto"
                placeholder="Ej. 3531015780"
                class="dark-input"
              ></v-text-field>
            </div>

            <div class="field">
              <label class="field-label">Domicilio</label>
              <v-text-field
                :rules="reglasDireccion"
                v-model="datosPersonales.direccion"
                outlined
                dense
                hide-details="auto"
                placeholder="Calle, número, colonia"
                class="dark-input"
              ></v-text-field>
            </div>

            <div class="field">
              <label class="field-label">Edad</label>
              <v-text-field
                :rules="reglasEdad"
                v-model="datosPersonales.edad"
                outlined
                dense
                hide-details="auto"
                placeholder="18"
                class="dark-input"
              ></v-text-field>
            </div>
          </div>

          <div class="step-actions">
            <button
              class="btn-primary"
              :disabled="!formDatosPersonales"
              @click="e6 = 2"
            >
              Continuar
            </button>
            <button class="btn-text" @click="$router.push('/miembros')">
              Cancelar
            </button>
          </div>
        </v-form>
      </v-stepper-content>

      <!-- Paso 2: Datos de contacto -->
      <v-stepper-step :complete="e6 > 2" step="2">
        Datos de contacto
        <small>Rellena los siguientes campos en caso de algún accidente</small>
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-form ref="formPaso2" v-model="formDatosContacto" class="dark-form">
          <div class="step-card">
            <div class="switch-row">
              <v-switch
                v-model="datosContacto.sufreEnfermedad"
                label="¿Sufre alguna enfermedad crónica?"
                hide-details
                class="dark-switch"
              ></v-switch>
            </div>
            <div class="field" v-if="datosContacto.sufreEnfermedad">
              <label class="field-label">Enfermedades</label>
              <v-text-field
                v-model="datosContacto.enfermedad"
                outlined
                dense
                hide-details="auto"
                placeholder="Escribe las enfermedades"
                class="dark-input"
              ></v-text-field>
            </div>

            <div class="switch-row">
              <v-switch
                v-model="datosContacto.tieneSeguro"
                label="¿Cuenta con seguro médico?"
                hide-details
                class="dark-switch"
              ></v-switch>
            </div>
            <div class="field" v-if="datosContacto.tieneSeguro">
              <label class="field-label">Institución médica</label>
              <v-text-field
                v-model="datosContacto.institucion"
                outlined
                dense
                hide-details="auto"
                placeholder="Ej. IMSS, ISSSTE"
                class="dark-input"
              ></v-text-field>
            </div>
            <div class="field" v-if="datosContacto.tieneSeguro">
              <label class="field-label">NSS / número de afiliación</label>
              <v-text-field
                v-model="datosContacto.afiliacion"
                outlined
                dense
                hide-details="auto"
                placeholder="Número de afiliación"
                class="dark-input"
              ></v-text-field>
            </div>

            <div class="section-divider"></div>
            <span class="mini-eyebrow">Contacto de emergencia</span>

            <div class="field">
              <label class="field-label">Nombre de contacto</label>
              <v-text-field
                :rules="reglasForm"
                v-model="datosContacto.nombreContacto"
                outlined
                dense
                hide-details="auto"
                placeholder="Nombre completo"
                class="dark-input"
              ></v-text-field>
            </div>
            <div class="field">
              <label class="field-label">Teléfono</label>
              <v-text-field
                :rules="reglasForm"
                v-model="datosContacto.telefonoContacto"
                outlined
                dense
                hide-details="auto"
                placeholder="Teléfono de contacto"
                class="dark-input"
              ></v-text-field>
            </div>
          </div>

          <div class="step-actions">
            <button
              class="btn-primary"
              :disabled="!formDatosContacto"
              @click="e6 = 3"
            >
              Continuar
            </button>
            <button class="btn-text" @click="e6 = 1">Regresar</button>
          </div>
        </v-form>
      </v-stepper-content>

      <!-- Paso 3: Foto -->
      <v-stepper-step :complete="e6 > 3" step="3">
        Foto
        <small>Escoge alguna foto del miembro</small>
      </v-stepper-step>

      <v-stepper-content step="3">
        <div class="step-card">
          <div class="field">
            <label class="field-label">Foto</label>
            <v-file-input
              :rules="reglaImagen"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Selecciona una imagen"
              prepend-icon="mdi-camera"
              outlined
              dense
              hide-details="auto"
              v-model="imagen"
              class="dark-input"
              @change="onSeleccionarImagen"
            ></v-file-input>
          </div>

          <div v-if="imagenUrl" class="preview-wrapper">
            <img :src="imagenUrl" alt="Vista previa" class="preview-image" />
          </div>

          <div class="section-divider"></div>
          <div class="switch-row">
            <v-switch
              v-model="cobrarInscripcion"
              label="¿Cobrar inscripción?"
              hide-details
              class="dark-switch"
            ></v-switch>
          </div>
          <div class="field" v-if="cobrarInscripcion">
            <label class="field-label">Monto de inscripción</label>
            <v-text-field
              v-model.number="montoInscripcion"
              type="number"
              outlined
              dense
              hide-details="auto"
              placeholder="Ej. 300"
              prefix="$"
              class="dark-input"
            ></v-text-field>
          </div>
        </div>

        <div class="step-actions">
          <button class="btn-primary" @click="registrar">Registrar</button>
          <button class="btn-text" @click="e6 = 2">Regresar</button>
        </div>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import Utiles from "../../Servicios/Utiles";
export default {
  name: "FormMiembro",
  props: ["miembro"],

  data: () => ({
    formDatosPersonales: false,
    formDatosContacto: false,
    reglasForm: [value => !!value || "Campo obligatorio."],
    reglaImagen: [
      value =>
        !value || value.size < 5000000 || "La foto debe ser menos de 5 MB"
    ],
    e6: 1,
    imagen: null,
    imagenUrl: null,
    datosPersonales: {
      nombre: "",
      telefono: "",
      direccion: "",
      edad: 18
    },
    datosContacto: {
      sufreEnfermedad: false,
      tieneSeguro: false,
      enfermedad: "",
      institucion: "",
      afiliacion: "",
      nombreContacto: "",
      telefonoContacto: ""
    },
    cobrarInscripcion: false,
    montoInscripcion: null,
    reglasNombre: [
      v => !!v || "El nombre es requerido",
      v => v.length >= 3 || "Mínimo 3 caracteres"
    ],
    reglasTelefono: [
      v => !!v || "El teléfono es requerido",
      v => /^[0-9]+$/.test(v) || "Solo se permiten números",
      v => v.length >= 7 || "Debe tener al menos 7 dígitos"
    ],
    reglasDireccion: [v => !!v || "El domicilio es requerido"],
    reglasEdad: [
      v => !!v || "La edad es requerida",
      v => /^[0-9]+$/.test(v) || "Solo se permiten números",
      v => parseInt(v) > 0 || "Debe ser mayor a 0"
    ]
  }),

  mounted() {
    this.formDatosPersonales = false;
    this.formDatosContacto = false;
  },

  methods: {
    registrar() {
      let miembro = {
        ...this.datosPersonales,
        ...this.datosContacto,
        imagen: this.imagenUrl,
        inscripcion:
          this.cobrarInscripcion && this.montoInscripcion > 0
            ? { monto: this.montoInscripcion }
            : null
      };

      this.$emit("registrado", miembro);

      this.cobrarInscripcion = false;
      this.montoInscripcion = null;
      this.formDatosPersonales = false;
      (this.formDatosContacto = false), (this.e6 = 1);
      this.imagen = null;
      this.imagenUrl = null;
      this.datosPersonales = {
        nombre: "",
        telefono: "",
        direccion: "",
        edad: 18
      };
      this.datosContacto = {
        sufreEnfermedad: false,
        tieneSeguro: false,
        enfermedad: "",
        institucion: "",
        afiliacion: "",
        nombreContacto: "",
        telefonoContacto: ""
      };
    },

    crearImagen(imagen) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imagenUrl = e.target.result;
      };
      reader.readAsDataURL(imagen);
    },

    onSeleccionarImagen() {
      if (!this.imagen) {
        return;
      }
      this.crearImagen(this.imagen);
    }
  },

  watch: {
    miembro: {
      deep: true,
      handler() {
        // Copiamos los datos (no asignamos la misma referencia) para que
        // escribir en los campos del formulario NO mute el prop `miembro`
        // original — si lo hiciera, dispararía este mismo watch deep en
        // cada tecla que el usuario escribe, causando revalidaciones en
        // cadena y el efecto de "como si se recargara".
        this.datosPersonales = { ...this.miembro.datosPersonales };
        this.datosContacto = { ...this.miembro.datosContacto };
        this.imagenUrl = Utiles.generarURL(this.miembro.imagen);

        // Cuando los datos llegan de forma asíncrona (modo edición) y
        // rellenan los campos automáticamente (no porque el usuario haya
        // escrito), Vuetify a veces no recalcula a tiempo la validez del
        // formulario — dejando "Continuar" deshabilitado aunque los
        // campos se vean llenos y correctos. Forzamos la revalidación
        // explícita en el siguiente tick, ya con el DOM actualizado.
        this.$nextTick(() => {
          if (this.$refs.formPaso1 && this.datosPersonales) {
            this.formDatosPersonales = this.$refs.formPaso1.validate();
          }
          if (this.$refs.formPaso2 && this.datosContacto) {
            this.formDatosContacto = this.$refs.formPaso2.validate();
          }
        });
      }
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap");

/* ===== TOKENS ===== */
.form-miembro-wrapper {
  --bg: #0e0e10;
  --card: #17171a;
  --card-border: #26262a;
  --text-primary: #f2f2ed;
  --text-secondary: #8c8c93;
  --text-tertiary: #5c5c62;
  --accent: #c8ff4d;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --error: #ff6b6b;
  --radius: 4px;

  --font-display: "Space Grotesk", sans-serif;
  --font-body: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: "JetBrains Mono", monospace;

  font-family: var(--font-body);
  color: var(--text-primary);
}

.step-card {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.switch-row {
  display: flex;
  align-items: center;
}

.section-divider {
  height: 1px;
  background: var(--card-border);
  margin: 4px 0;
}

.mini-eyebrow {
  font-family: var(--font-mono);
  font-size: 10.5px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-tertiary);
  margin-top: -8px;
}

.preview-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.preview-image {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: var(--radius);
  border: 1px solid var(--card-border);
}

.step-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 11px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

.btn-text {
  background: transparent;
  border: none;
  color: var(--text-tertiary);
  font-size: 13px;
  padding: 8px 4px;
  cursor: pointer;
  transition: color 0.15s ease;
}

.btn-text:hover {
  color: var(--text-primary);
}

/* ===== Overrides v-stepper (Vuetify) ===== */
.dark-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

.dark-stepper >>> .v-stepper__header {
  display: none;
}

.dark-stepper >>> .v-stepper__step {
  padding: 16px 0;
}

.dark-stepper >>> .v-stepper__step__step {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  color: var(--text-secondary) !important;
  box-shadow: none !important;
}

.dark-stepper >>> .v-stepper__step--active .v-stepper__step__step {
  background: var(--accent) !important;
  border-color: var(--accent) !important;
  color: var(--bg) !important;
}

.dark-stepper >>> .v-stepper__step--complete .v-stepper__step__step {
  background: var(--accent-dim) !important;
  border-color: var(--accent) !important;
  color: var(--accent) !important;
}

.dark-stepper >>> .v-stepper__step__step .v-icon {
  color: var(--bg) !important;
}

.dark-stepper >>> .v-stepper__label {
  color: var(--text-primary) !important;
  font-family: var(--font-display) !important;
  font-weight: 700 !important;
  font-size: 14.5px !important;
}

.dark-stepper >>> .v-stepper__label small {
  color: var(--text-tertiary) !important;
  font-family: var(--font-body) !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}

.dark-stepper >>> .v-stepper__content {
  padding: 0 0 0 36px !important;
  margin: 0 0 0 20px !important;
  border-left: 1px solid var(--card-border) !important;
}

.dark-stepper >>> .v-stepper__wrapper {
  background: transparent !important;
}

/* ===== Overrides v-text-field / v-file-input (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> .v-file-input__text {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

.dark-input >>> .v-file-input__text--placeholder {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-chip {
  background: var(--accent-dim) !important;
  color: var(--accent) !important;
}

/* ===== Overrides v-switch (Vuetify) ===== */
.dark-switch >>> label {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13.5px !important;
}

.dark-switch >>> .v-input--switch__track {
  background: var(--card-border) !important;
  opacity: 1 !important;
}

.dark-switch >>> .v-input--switch__thumb {
  background: var(--text-tertiary) !important;
}

.dark-switch >>> .v-input--is-dirty .v-input--switch__track {
  background: var(--accent) !important;
  opacity: 0.4 !important;
}

.dark-switch >>> .v-input--is-dirty .v-input--switch__thumb {
  background: var(--accent) !important;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 600px) {
  .dark-stepper >>> .v-stepper__content {
    padding-left: 20px !important;
    margin-left: 12px !important;
  }

  .step-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Miembros/FormMiembro.vue